import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, Brush,
} from "recharts";
import { useSelector } from "react-redux";
import { Colors } from "../../../constants/colors";

const AverageScoreChart = ({ data, value,smoothLine }) => {
    const labelFontSize = useSelector((state) => {
        const fontSizes = state.fontManager.fontSizes;
        const normalizedKey = Object.keys(fontSizes).find(
            (key) => key.trim() === "labelFontSize",
        );
        return fontSizes[normalizedKey]  || 16;
    });
    const formatTooltipValue = (value) => value.toFixed(1);
    const rawMin = Math.min(...data.map(item => item.average));
    const rawMax = Math.max(...data.map(item => item.average));

    const padding = (rawMax - rawMin) * 0.01;
    const minScore = (rawMin ).toFixed( 1);
    const maxScore = Math.ceil(rawMax + padding);

    return (
        <ResponsiveContainer width="100%" height={'100%'}  >
            <LineChart
                data={data}
                margin={{
                    top: 0,
                    right: 10,
                    bottom: 50,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis
                    dataKey="label"
                    tick={{ fontSize: 16, fill: "#333", fontWeight: "500" }}
                    label={{ position: "insideBottom", dy: 20, fontSize: 16, fill: "#555" }}
                    interval="preserveStartEnd"
                />
                <YAxis
                    tick={{ fontSize: 16, fill: "#333" }}
                    domain={[parseFloat(minScore), parseFloat(maxScore)]}
                />
                <Tooltip
                    contentStyle={{ backgroundColor: "#f5f5f5", borderRadius: "10px" }}
                    labelStyle={{ fontWeight: "bold" }}
                    formatter={formatTooltipValue}
                />
                <Legend
                    wrapperStyle={{ bottom: -10, fontSize: `${labelFontSize}px` }}
                    align="center"
                    verticalAlign="top"
                    iconType="circle"
                />
                <Line
                    type={smoothLine ? "monotone" : "linear"}
                    dataKey="average"
                    name={`Average ${value}`}
                    stroke="#8884d8"
                    strokeWidth={3}
                    dot={false}
                    activeDot={{ r: 6, stroke: "#8884d8", strokeWidth: 2 }}
                />
                <defs>
                    <linearGradient id="brushGreyGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#B0B0B0" stopOpacity={0.7} />
                        <stop offset="50%" stopColor="#D3D3D3" stopOpacity={0.5} />
                        <stop offset="100%" stopColor="#F5F5F5" stopOpacity={0.3} />
                    </linearGradient>
                </defs>
                <Brush
                    dataKey="label"
                    height={35}
                    stroke={Colors.gray7}
                    fill="url(#brushGreyGradient)"
                    travellerWidth={28}
                    travellerStyle={{
                        stroke: "#555",
                        fill: "#777",
                        cursor: "pointer",
                    }}
                    selectedBoxStyle={{
                        stroke: "#555",
                        fill: "rgba(175,168,168,0.3)",
                        cursor: "move",
                    }}
                    gap={1}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default AverageScoreChart;
